import React, { ReactNode } from "react";
import { View, Text, TextStyle, ViewStyle } from "react-native";

interface TextViewProps {
  title?: string;
  textStyle?: any;
  boxStyle?: any;
  children?: ReactNode;
  numberoflines?: number;
  other?: any;
}

const TextView: React.FC<TextViewProps> = ({
  title,
  textStyle,
  boxStyle,
  children,
  numberoflines,
  other
}) => (
  <View style={boxStyle}>
    <Text style={textStyle} numberOfLines={numberoflines} ellipsizeMode='tail' {...other} >{title}</Text>
    {children}
  </View>
);

export default TextView;
